import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import Services from "./components/Services";
import BookingForm from "./components/BookingForm";
import BookedAppointments from "./components/BookedAppointments";
import AppointmentCalendar from "./components/AppointmentCalendar";
import AddAppointment from "./components/AddAppointment";
import Footer from "./components/Footer";
import "./index.css";
import CarCarousel from "./components/CarCarousel";
import About from "./components/About";
import LocationMap from "./components/LocationMap";
import Login from "./components/Login";
import { AuthProvider } from "./AuthContext";
import { NavigationSettingsProvider } from "./NavigationSettingsContext";
import Impressum from "./components/Impressum";
import AdminUsers from "./components/AdminUsers";
import RequireAdmin from "./components/RequireAdmin";
import RequireRoles from "./components/RequireRoles";
import AnnouncementPage from "./components/AnnouncementPage";
import Feedback from "./components/Feedback";
import AnnouncementBanner from "./components/AnnouncementBanner";
import OpeningTimes from "./components/OpeningTimes";
import AdminCars from "./components/AdminCars";
import Vacations from "./components/Vacations";
import AdminServices from "./components/AdminServices";
import SettingsPage from "./components/SettingsPage";
import { SupplyProvider } from "./supply/context/SupplyContext";
import VehicleSearchPage from "./supply/pages/VehicleSearchPage";
import PartsCatalogPage from "./supply/pages/PartsCatalogPage";
import OfferComparisonPage from "./supply/pages/OfferComparisonPage";
import BasketCheckoutPage from "./supply/pages/BasketCheckoutPage";
import OrderHistoryPage from "./supply/pages/OrderHistoryPage";
import InvoiceReviewListPage from "./supply/pages/InvoiceReviewListPage";
import InvoiceReviewDetailPage from "./supply/pages/InvoiceReviewDetailPage";
import WorkOrdersPage from "./components/WorkOrdersPage";
import CustomersPage from "./components/CustomersPage";
import CustomerDetailPage from "./components/CustomerDetailPage";
import VehiclesPage from "./components/VehiclesPage";
import VehicleDetailPage from "./components/VehicleDetailPage";
import InventoryOverviewPage from "./inventory/pages/InventoryOverviewPage";
import InventoryDetailPage from "./inventory/pages/InventoryDetailPage";
import DevOpsDashboardPage from "./devops/pages/DevOpsDashboardPage";

function App() {
    return (
        <AuthProvider>
            <NavigationSettingsProvider>
                <SupplyProvider>
                    <Router>
                        <div className="flex min-h-screen flex-col">
                            <Header />

                            <main className="flex-grow pb-16">
                                <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <>
                                            <AnnouncementBanner />
                                            <div className="flex flex-col lg:flex-row gap-6">
                                                {/* Linke Spalte: Hauptinhalt */}
                                                <div className="flex-1">

                                                    <div
                                                        className="relative bg-cover bg-center py-20"
                                                        style={{ backgroundImage: "url('/images/hertingen.jpg')" }}
                                                    >
                                                        <div className="relative z-10">
                                                            <HeroSection />
                                                            <Services />
                                                        </div>
                                                    </div>
                                                    <CarCarousel />
                                                    <LocationMap />
                                                </div>

                                                {/* Rechte Spalte: BookingForm fixiert auf Desktop, unten angehängt auf Mobil */}
                                                <div className="w-full lg:w-1/4">
                                                    <div className="lg:sticky lg:top-20">
                                                        <BookingForm />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                />
                                <Route
                                    path="/appointments"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT"]}><BookedAppointments /></RequireRoles>}
                                />
                                <Route
                                    path="/appointments/new"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT"]}><AddAppointment /></RequireRoles>}
                                />
                                <Route
                                    path="/calendar"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT"]}><AppointmentCalendar /></RequireRoles>}
                                />
                                <Route
                                    path="/work-orders"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT", "MECHANIKER"]}>
                                            <WorkOrdersPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/inventory"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT", "LAGERIST"]}>
                                            <InventoryOverviewPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/inventory/:id"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT", "LAGERIST"]}>
                                            <InventoryDetailPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/customers"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT", "MECHANIKER"]}><CustomersPage /></RequireRoles>}
                                />
                                <Route
                                    path="/customers/:id"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT", "MECHANIKER"]}><CustomerDetailPage /></RequireRoles>}
                                />
                                <Route
                                    path="/vehicles"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT", "MECHANIKER"]}><VehiclesPage /></RequireRoles>}
                                />
                                <Route
                                    path="/vehicles/:id"
                                    element={<RequireRoles allowed={["ADMIN", "DISPONENT", "MECHANIKER"]}><VehicleDetailPage /></RequireRoles>}
                                />
                                <Route path="/admin/users" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />
                                <Route path="/admin/cars" element={<RequireAdmin><AdminCars /></RequireAdmin>} />
                                <Route path="/admin/services" element={<RequireAdmin><AdminServices /></RequireAdmin>} />
                                <Route path="/settings" element={<RequireAdmin><SettingsPage /></RequireAdmin>} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/impressum" element={<Impressum />} />
                                <Route path="/announcement" element={<RequireAdmin><AnnouncementPage /></RequireAdmin>} />
                                <Route path="/feedback" element={<RequireAdmin><Feedback /></RequireAdmin>} />
                                <Route path="/opening-times" element={<RequireAdmin><OpeningTimes /></RequireAdmin>} />
                                <Route path="/vacations" element={<RequireAdmin><Vacations /></RequireAdmin>} />
                                <Route
                                    path="/supply/vehicle-search"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <VehicleSearchPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/catalog"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <PartsCatalogPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/offers"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <OfferComparisonPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/basket"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <BasketCheckoutPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/orders"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <OrderHistoryPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/invoices"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <InvoiceReviewListPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/supply/invoices/:invoiceId"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <InvoiceReviewDetailPage />
                                        </RequireRoles>
                                    }
                                />
                                <Route
                                    path="/devops/monitoring"
                                    element={
                                        <RequireRoles allowed={["ADMIN", "DISPONENT"]}>
                                            <DevOpsDashboardPage />
                                        </RequireRoles>
                                    }
                                />
                                </Routes>
                            </main>
                            <Footer />
                        </div>
                    </Router>
                </SupplyProvider>
            </NavigationSettingsProvider>
        </AuthProvider>
    );
}

export default App;
